<template>
  <div class="entered-registrar">
    <entered-common
      ref="entered"
      :perSignUp="hasPermission('minister_sign_up')"
      :perDiscSignUp="hasPermission('minister_disc_sign_up')"
      :perDetail="hasPermission('minister_detail')"
      keyId="ministerhd"
      @close="clear"
      @open="enter"
    ></entered-common>
    <el-dialog :title="`部长报名（${curItem.name}）`" :visible.sync="dialogVisibleAdd" width="650px" @closed="clear">
      <ly-form
        class="enter-form"
        :formConfig="formConfig"
        :formKeys="formKeysEntered"
        :defaultFormItem="defaultFormItem"
        ref="lyFormSignUp"
        @change="signUpChange"
      >
        <template v-slot:real_class_count="{ item, formData }">
          <el-input
            :placeholder="item.placeholder"
            v-model.trim="formData.real_class_count"
            @change="value => changeRealCount(formData, value)"
          >
            <template slot="append">
              <del>正常课次：{{ curItem.courses_count }}</del>
            </template>
          </el-input>
        </template>
        <template v-slot:sign_up_fee="{ item, formData }">
          <el-input
            :placeholder="item.placeholder"
            :disabled="item.options.disabled"
            v-model.trim="formData.sign_up_fee"
          >
            <template slot="append">
              <span>
                （元）
                <del>原价：{{ curItem.total_fee }}元</del>
              </span>
            </template>
          </el-input>
        </template>
      </ly-form>
      <div class="use-reserved p-l-15 none">
        <el-checkbox :disabled="true" :value="1" :true-label="1" :false-label="0"
          >使用部长名额（{{ curItem.minister_sign_up_count ? curItem.minister_sign_up_count + 1 : 1 }}/{{
            globalConfig.minister_quota
          }}）</el-checkbox
        >
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleAdd = false">取 消</el-button>
        <el-button type="primary" @click.native="signUp" :loading="loading">报 名</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { Checkbox, Dialog, Input } from 'element-ui';

import LyForm from '@/components/LyForm';
import { enteredFormItem } from '@/utils/formConfig';
import { contact, sys } from '@/api';
import pattern from '@/utils/pattern';
import enterMixin from '@/utils/enterMixin';
import enteredCommon from '@/components/enteredCommon';
import perMixin from '@/utils/perMixin';
import checkConflict from '@/utils/signUpConflict';

const Decimal = require('decimal.js/decimal.js');

export default {
  name: 'EnteredMinster',
  mixins: [enterMixin, perMixin],
  components: {
    ElDialog: Dialog,
    ElInput: Input,
    LyForm,
    enteredCommon,
    ElCheckbox: Checkbox
  },
  data() {
    return {
      loading: false,
      signDataTmp: {},
      formConfig: {
        'label-width': '120px',
        'label-position': 'left',
        ref: 'ly-form',
        inline: false,
        itemSpan: 24
      },
      curItem: {},
      dialogVisibleAdd: false,
      formKeysEntered: [],
      globalConfig: {},
      defaultFormItem: {},
      formKeysEnteredTmp: {}
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      contact.discountReasonQuery().then(res => {
        if (res) {
          enteredFormItem.discount_reason_id.options.select = res.data.list;
          this.formKeysEntered = enteredFormItem;
          const tmp = window.cloneDeep(enteredFormItem);
          delete tmp.discount_reason_id;
          delete tmp.discount_rate;
          this.formKeysEnteredTmp = tmp;
        }
      });
      sys.globalConfig({}).then(res => {
        if (res && res.data) {
          this.globalConfig = res.data.global_config.config;
        }
      });
    },
    enter(row, status) {
      if (status !== 'discount') {
        this.formKeysEntered = this.formKeysEnteredTmp;
      } else {
        this.formKeysEntered = enteredFormItem;
      }
      this.curItem = { ...row };
      // 部长报名已经用完
      if (this.globalConfig.minister_quota <= row.minister_sign_up_count) {
        this.$message.warning('部长名额已用完，请使用其他方式！');
        return;
      }
      if (row.class_phase === 2) {
        // 上课中
        this.$confirm('当前班级已开课，报名后属于插班生，是否继续报名？', '提示', {
          type: 'warning'
        })
          .then(() => {
            this.dialogVisibleAdd = true;
            this.getInitData();
          })
          .catch(() => {});
      } else {
        this.dialogVisibleAdd = true;
        this.getInitData();
      }
    },
    async signUp() {
      const { data, valid } = await this.$refs.lyFormSignUp.getFormData();
      if (valid) {
        this.loading = true;
        // 检测冲突
        const isRight = await checkConflict({ class_id: this.curItem.id, contact_ids: [data.contact_id] });
        if (!isRight) {
          this.loading = false;
          return;
        }
        if (!Object.prototype.hasOwnProperty.call(this.signDataTmp, 'is_shift')) {
          const resSign = await contact.getSignUpFee({
            params: {
              class_id: this.curItem.id
            }
          });
          if (resSign && resSign.data) this.signDataTmp = resSign.data;
        }

        const params = {
          ...this.signDataTmp,
          ...data,
          class_id: this.curItem.id,
          discount_rate: data.discount_rate ? Decimal.div(data.discount_rate, 100).toNumber() : ''
        };
        if (!params.discount_reason_id) delete params.discount_reason_id;
        if (params.discount_rate === '') delete params.discount_rate;

        const res = await contact.ministerSignUp({
          params
        });
        if (res) {
          this.$message.success(res.msg || '报名成功！');
          this.dialogVisibleAdd = false;
          this.search();
        }
        this.loading = false;
      }
    },
    async signUpChange(formData, key) {
      // eslint-disable-next-line no-param-reassign
      if (formData.discount_rate === '') formData.sign_up_fee = this.curItem.total_fee;

      if (formData.discount_reason_id) {
        const tmp = this.formKeysEntered.discount_reason_id.options.select.find(
          item => item.id === formData.discount_reason_id
        );
        // eslint-disable-next-line no-param-reassign
        if (key !== 'discount_rate') formData.discount_rate = tmp.rate ? Decimal.mul(tmp.rate, 100).toNumber() : '';
        if (pattern.decimal.test(formData.discount_rate)) {
          this.loading = true;
          if (pattern.integer.test(formData.real_class_count)) {
            this.getInitData(this.curItem.courses_count - formData.real_class_count, formData);
          }
          this.loading = false;
        }
      }
    },
    getInitData(shift_class_number, formData) {
      const params = {
        class_id: this.curItem.id,
        shift_class_number
      };
      if (formData && pattern.integer.test(formData.discount_rate)) {
        params.discount_rate = Decimal.div(formData.discount_rate, 100).toNumber();
      }
      contact
        .getSignUpFee({
          params
        })
        .then(res => {
          if (res && res.data) {
            if (formData) {
              Object.keys(formData).forEach(key => {
                // eslint-disable-next-line no-param-reassign
                if (res.data[key]) formData[key] = res.data[key];
                // eslint-disable-next-line no-param-reassign
                formData.sign_up_fee = res.data.fee;
              });
            } else {
              this.defaultFormItem = {
                ...this.defaultFormItem,
                sign_up_fee: res.data.fee,
                discount_rate: this.defaultFormItem.discount_rate || '',
                real_class_count: this.curItem.courses_count - res.data.shift_class_number
              };
            }
            this.signDataTmp = res.data;
          }
        });
    },
    changeRealCount(formData, value) {
      if (!pattern.integer.test(value)) {
        this.$message.error('请填写正确的课次');
        // eslint-disable-next-line no-param-reassign
        formData.real_class_count = this.curItem.courses_count - this.signDataTmp.shift_class_number;
        return;
      }
      if (value > this.curItem.courses_count) {
        // eslint-disable-next-line no-param-reassign
        formData.real_class_count = this.curItem.courses_count - this.signDataTmp.shift_class_number;
        return;
      }
      this.getInitData(this.curItem.courses_count - value, formData);
    },
    clear() {
      this.$refs.lyFormSignUp.resetFields();
    },
    search() {
      this.$refs.entered.search();
    }
  }
};
</script>
